export default __webpack_public_path__ + "static/media/auto_routing.d0215ef6.svg";